/**
 * @file 全局逻辑
 */
import "reset-css";
import Constants from "@/constants";
import { isMobile, isPC, isPCAnchor, loadScript, GETCOOKIE } from "@/utils";
import { initReporter } from "@huyafed/gametool-report";
import { TOOL_ID, TOOL_TYPE } from "@/config/env";
import { HUYASdk } from "@huyafed/huya-kiwi";
import { tafSdk, tafFetch } from "@/api/_tafFetch";

document.title = import.meta.env.VITE_TITLE as string;
/**
 * @description 开启调试
 */
if (Constants.IS_DEBUG || Constants.IS_USEDEBUG) {
  // 开启tafFetch日志打印
  localStorage._wsLog = 1;
  loadScript("https://diy-assets.msstatic.com/diyComps/vconsole.min.js").then(() => {
    if ((window as any).VConsole) new (window as any).VConsole();
    console.log("当前url", window.location.href);
  });
}

// 数据中台上报初始化（自动上报启动事件和心跳，同时上报用户工具使用记录）
initReporter(TOOL_ID, TOOL_TYPE, tafFetch)
  .catch((err) => console.error("initReporter failed:", err));

/** 注入 DIN 字体 */
const injectDIN = () => {
  const injectStyles = (urls: string[]) => {
    setTimeout(() => {
      urls.forEach(url => {
        const linkElement = document.createElement("link");
        linkElement.rel = "stylesheet";
        linkElement.crossOrigin = "";
        linkElement.href = url;
        document.head.appendChild(linkElement);
      });
    }, 200);
  };
  injectStyles([
    /** 优先使用 DinCoros */
    // "https://diy-assets.msstatic.com/PrivateCall/font/DIN.css",
    "https://diy-assets.msstatic.com/fonts/DinCoros.css",
  ]);
};

injectDIN();

/**
 * @description 在移动端、pc端，注入pageSpy
 * @see https://page-spy.huya.info/#/room-list
 */
const injectPageSpy = () => {
  const isValidPlatform = isMobile || isPC || isPCAnchor;
  const shouldInject = Constants.IS_DEBUG || Constants.IS_USEDEBUG;
  if (isValidPlatform && shouldInject) {
    loadScript("https://page-spy.huya.info/page-spy/index.min.js").then(() => {
      if ((window as any).PageSpy) {
        // 自定义标题，方便搜索，比如“贵族”、“星耀计划”等等业务页面名称
        const title = import.meta.env.VITE_TITLE;
        new (window as any).PageSpy({
          title: `${title}-${GETCOOKIE("udb_uid")}`,
          autoRender: true,
        });
      }
    });
  }
};

injectPageSpy();

/**
 * 初始化 HUYASdk 配置
 */
const initHUYASdkConfig = () => {
  HUYASdk.config({
    /** 提供调Taf接口能力 */
    tafApiConfig: { tafSdk },
    /** 测试环境识别 */
    isTestEnv: Constants.IS_TAF_TEST,
    /** 开启跨域api */
    useCrossDomainApi: true,
  });
};

initHUYASdkConfig();
